<template>
  <div v-if="transactions && transactions.length"> 
    <table-blue-summary :cashIn="coinIn" :cashOut="coinOut" />
    <table-blue v-if="transactions && transactions.length > 0"  :cols="cols">
      <tr v-for="(transaction, index) in transactions" :key="index" :class="index % 2 ? 'even' : 'odd'">
        <table-blue-label-invoice :invoice="transaction.invoice" :playerId="transaction.playerId" />
        <table-blue-label-date :timestamp="transaction.timestamp" />
        <table-blue-label-action :action="transaction.action" />
        <table-blue-label-amount :action="transaction.action" :amount="transaction.amount" />
        <table-blue-label-ip :ip="transaction.sourceIp" />
        <table-blue-label-description :description="transaction.description || ''" />
        <td><table-blue-button-events :playerId="transaction.playerId"  style="float: right;"/></td>
      </tr>
    </table-blue>
    <table-blue-label-count :amount="transactions.length" />
  </div>
  <table-blue-no-result v-else />
</template>

<script>
  import TableBlue from './TableBlue/TableBlue.vue';
  import TableBlueSummary from './TableBlue/TableBlueSummary';
  import TableBlueButtonEvents from './TableBlue/TableBlueButtonEvents.vue';
  import TableBlueLabelAction from './TableBlue/TableBlueLabelAction';
  import TableBlueLabelAmount from './TableBlue/TableBlueLabelAmount';
  import TableBlueLabelInvoice from './TableBlue/TableBlueLabelInvoice';
  import TableBlueLabelDate from './TableBlue/TableBlueLabelDate';
  import TableBlueLabelDescription from './TableBlue/TableBlueLabelDescription';
  import TableBlueLabelIp from './TableBlue/TableBlueLabelIp';
  import TableBlueLabelCount from './TableBlue/TableBlueLabelCount';
  import TableBlueNoResult from './TableBlue/TableBlueNoResult';

  export default {
    name: "TableBlueInvoiceHistory",
    props: ['transactions'],
    components: {
      TableBlue,
      TableBlueSummary,
      TableBlueButtonEvents,
      TableBlueLabelAction,
      TableBlueLabelAmount,
      TableBlueLabelInvoice,
      TableBlueLabelDate,
      TableBlueLabelDescription,
      TableBlueLabelIp,
      TableBlueLabelCount,
      TableBlueNoResult,
    },
    data() {
      return {
        cols: [
          { i18n: 'th.invoice',     align: 'center' },
          { i18n: 'th.date',        align: 'center' },
          { i18n: 'th.action',      align: 'center' },
          { i18n: 'th.amount',      align: 'right' },
          { i18n: 'th.ip',          align: 'center', },
          { i18n: 'th.description', align: 'center' },
          { i18n: '',               align: 'right' },
        ]
      }
    },
    computed: {
      coinIn() {
        return this.transactions
          .filter(item => item.action === 'DEPOSIT' || item.action === 'CREATE')
          .map(item => item.amount)
          .reduce((c, n) => c + n, 0);
      },
      coinOut() {
        return this.transactions
          .filter(item => item.action === 'WITHDRAW' || item.action === 'REMOVE')
          .map(item => item.amount)
          .reduce((c, n) => c + n, 0);
      } 
    }
  }
</script>
